"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSplitUserKey = exports.setSplitUserKeyCookie = void 0;
const uuid_1 = require("uuid");
const browser_1 = require("../../helpers/browser");
const constants_1 = require("./constants");
const setSplitUserKeyCookie = function () {
  let uuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if ((0, browser_1.isServerSideRendering)()) return '';
  if (uuid === null) {
    uuid = (0, uuid_1.v4)();
  }
  (0, browser_1.setCookie)(constants_1.SPLIT_IO_USER_KEY_COOKIE, uuid);
  (0, browser_1.setLocalStorageKey)(constants_1.SPLIT_IO_USER_KEY_COOKIE, uuid);
  return uuid;
};
exports.setSplitUserKeyCookie = setSplitUserKeyCookie;
const getSplitUserKey = () => {
  if ((0, browser_1.isServerSideRendering)()) return '';
  let key = (0, browser_1.getCookie)(constants_1.SPLIT_IO_USER_KEY_COOKIE);
  if (!key) {
    key = (0, browser_1.getLocalStorageKey)(constants_1.SPLIT_IO_USER_KEY_COOKIE);
  }
  // Make sure local storage and cookie are both up to date.
  return (0, exports.setSplitUserKeyCookie)(key);
};
exports.getSplitUserKey = getSplitUserKey;